import { Component, OnInit } from '@angular/core';
// import {UsersService} from "../users/shared/users.service";
// import {User} from "../users/shared/user";
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
 import { UtilsService } from '../shared/utils-service';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar} from '@angular/material';
@Component({
  selector: 'app-submit-telco',
  templateUrl: './submit-telco.component.html',
  styleUrls: ['./submit-telco.component.css']
})
export class SubmitTelcoComponent implements OnInit {

	showPopup: boolean = false;
	private showAdvanced: boolean;
	private fullArray: Array<any> = [];
	private backupArray: Array<any> = [];
	private newObject: any = {};
	private editMode: boolean;
	private normalMode: boolean;
	private addRow: boolean;
	private currDate: Date;
	private telcoURL: string = this.utils.url+"/ddmfenquiry/enquireBlackListCustomers";
	dataJson: any = [];
	key: string = '';
  // private users: User[] = [];
  private loggedInUser: any = {};
	constructor(private http: Http, private router: Router, private utils: UtilsService,private matSnackBar: MatSnackBar) {
		this.loggedInUser = this.utils._checkSession({'page': 'submit-telco'});
		this.showAdvanced = false;
		this.showPopup = false;
		this.normalMode = false;
		this.addRow = false;
	}

	ngOnInit() {
   

	}
		 
	editToggle(h){
		this.editMode = h;
		//console.log(h, 'edit mode');
		if (h) {
			this.backupArray = JSON.parse(JSON.stringify(this.fullArray));
			// console.log(this.fullArray, this.backupArray, 'full back if');
		} else {
			this.fullArray = JSON.parse(JSON.stringify(this.backupArray));
			// console.log(this.fullArray, this.backupArray, 'else mode');
		}
	}

	submitMyTelco() {
		if(!this.addRow){
		this.editMode = false;
		// debugger;
		//console.log(this.fullArray);
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);

		let data = {
			"userId":this.loggedInUser.userId,
			"isEnquiryAllTelco": "true",
			"enquireBlackListSearchCriteriaList": this.fullArray
		} ;

		let bodyJson = JSON.stringify(data);

		// console.log(bodyJson);

		this.http.post(this.telcoURL, bodyJson, {headers: headers}).subscribe(res => {
			let result = JSON.parse(res['_body']);
			this.dataJson = result['enquireBlackListPerCustomerList'];
			var message=result['ddmfResponseStatus'].responseStatusMessage;
			this.utils.notify(message);
			//console.log(this.dataJson);
			this.showPopup = true;
		},
		error => {
			// this.matSnackBar.open('Something went wrong!! Please try after some time.', 'Close', {
   //    			duration: 5000,
   //  		});
			this.utils.notify('Something went wrong!! Please try after some time.');
		});
		this.currDate = new Date();
	
		}
	}
	addNewRow() {
		if (this.newObject['icNo'] || this.newObject['newIcNo'] || this.newObject['brNo'] || this.newObject['name']) {
			this.fullArray.push(this.newObject);
			this.newObject = {};
		}
	}

	saveRow() {
		//console.log(this.newObject, 'newObject');
		if (this.newObject['icNo'] || this.newObject['newIcNo'] || this.newObject['brNo'] || this.newObject['name']) {
			this.fullArray.push(this.newObject);
			this.newObject = {};
			this.editMode = false;
			this.addRow = false;
		} else {
			this.utils.notify('You must key in IC, New IC, BR No or Name for each search!');
			
		}
	}

	editExistingRow(i) {
		//console.log(this.fullArray[i], i, this.newObject);
		if (this.fullArray[i]['icNo'] || this.fullArray[i]['newIcNo'] || this.fullArray[i]['brNo'] || this.fullArray[i]['name']) {
			this.editMode = false;
			this.addRow = false;
		}
	}

	deleteRow(i) {
		if(confirm("Are you sure you want to delete?")) {
			this.fullArray.splice(i, 1);
		}
	}
	
	cancelRow() {
		this.newObject = {};
		this.addRow = false;
	}
	
	cancel() {
	var result = confirm('You are trying to cancel the enquiry submission. All the records added for enquiry will be lost.\nAre you sure you want to proceed?')
      if(result){
          this.newObject = {};
		this.addRow = false;
		this.fullArray = [];
      }
	}
	goToURL(url){
		this.router.navigateByUrl(url);
		}

}



// WEBPACK FOOTER //
// ./src/app/submit-telco/submit-telco.component.ts